export const enum AppStagesEnum {
  INIT = 'init',
  REGISTRATION = 'registration',
  READY = 'ready',
  ERROR = 'error',
}
